import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { isWebView2 } from '@office-start/device-detection-utility';
import { fetchFeatureGates, getFeatureGates, } from '@office-start/feature-gates-service';
import { fetchFeatureSettings, getFeatureSettings, } from '@office-start/feature-settings-service';
import { OfficeWorkload } from '@office-start/officehome-types';
import { defaultLaunchUrl } from '../defaultLaunchUrl';
import { getResolvedUrl } from '../utilities/getResolvedUrl';
var launchUrlFunc;
export var launchUrl = function (url, launchUrlParams, launchInstrumentationParams, officeRouteParams, useAuthtokenFlow) { return __awaiter(void 0, void 0, void 0, function () {
    var context, useHwaLaunch, featureGatesResult, featureGates, _a, featureSettingsResult, featureSettings, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!!launchUrlFunc) return [3 /*break*/, 4];
                return [4 /*yield*/, fetchOfficeComponentContext()];
            case 1:
                context = _c.sent();
                useHwaLaunch = context.workload === OfficeWorkload.Hwa || isWebView2();
                if (!useHwaLaunch) return [3 /*break*/, 3];
                return [4 /*yield*/, import(
                    /* webpackChunkName: "hwalaunchurl" */ '../hwaLaunchUrl').then(function (module) { return module.hwaLaunchUrl; })];
            case 2:
                launchUrlFunc = _c.sent();
                return [3 /*break*/, 4];
            case 3:
                launchUrlFunc = defaultLaunchUrl;
                _c.label = 4;
            case 4:
                if (!(typeof url === 'string')) return [3 /*break*/, 11];
                featureGatesResult = getFeatureGates();
                if (!(featureGatesResult === null || featureGatesResult === void 0 ? void 0 : featureGatesResult.result)) return [3 /*break*/, 5];
                _a = featureGatesResult;
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, fetchFeatureGates()];
            case 6:
                _a = _c.sent();
                _c.label = 7;
            case 7:
                featureGates = _a;
                featureSettingsResult = getFeatureSettings();
                if (!(featureSettingsResult === null || featureSettingsResult === void 0 ? void 0 : featureSettingsResult.result)) return [3 /*break*/, 8];
                _b = featureSettingsResult;
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, fetchFeatureSettings()];
            case 9:
                _b = _c.sent();
                _c.label = 10;
            case 10:
                featureSettings = _b;
                url = getResolvedUrl(url, featureGates === null || featureGates === void 0 ? void 0 : featureGates.result, featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result);
                _c.label = 11;
            case 11: 
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return [2 /*return*/, launchUrlFunc(url, launchUrlParams, launchInstrumentationParams, officeRouteParams, useAuthtokenFlow)];
        }
    });
}); };
//# sourceMappingURL=launchUrl.js.map